import React, { useState, useEffect } from "react";
import { FaBars } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Collapse,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
  Checkbox,
  FormControlLabel,
  Button,
  CircularProgress
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp, Edit } from "@mui/icons-material";
import api from "../../Services/api";
import { downloadSmartTalksCsv } from "../../Services/exportSmartTalks";
import { currentConfig } from "../../Services/config";
import Sidebar from '../Sidebar';
import '../Home/home.css';

export const Enviados = () => {
  const navigate = useNavigate();
  const [sidebar, setSidebar] = useState(false);
  const [listemail, setlistemail] = useState([]);
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [situacao] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [expandedRow, setExpandedRow] = useState(null);
  const [atividadeFilter, setAtividadeFilter] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const isMobile = useMediaQuery('(max-width:600px)');

  // Adicionando states para filtro de data
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const [dataInicio, setDataInicio] = useState(getTodayDate());
  const [dataFim, setDataFim] = useState(getTodayDate());

  useEffect(() => {
    ValidaUsuario();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    filterEmails();
    // eslint-disable-next-line
  }, [searchTerm, listemail, dataInicio, dataFim, atividadeFilter]);

  const filterEmails = () => {  
    setFilteredEmails(
      listemail.filter((email) => {
        // Converter as datas para formato YYYY-MM-DD para comparação
        const emailDate = new Date(email.data_cadastro);
        const emailDateStr = emailDate.toISOString().split('T')[0]; // YYYY-MM-DD
        
        const startDateStr = dataInicio; // já está em formato YYYY-MM-DD
        const endDateStr = dataFim; // já está em formato YYYY-MM-DD
        
        const matchesSearch =
          email.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
          email.cpf.includes(searchTerm) ||
          email.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          email.telefone.includes(searchTerm);
        const matchesAtividade = !atividadeFilter || email.atividade === '1';
        
        // Comparar apenas as strings de data (YYYY-MM-DD)
        return (
          matchesSearch &&
          emailDateStr >= startDateStr && emailDateStr <= endDateStr &&
          matchesAtividade
        );
      })
    );
  };

  async function ValidaUsuario() {
    api.defaults.headers.post = { 'Content-Type': 'application/json' };
    api.defaults.headers.common = { 'x-access-token': localStorage.getItem("token") };

    let usuario = await buscaUsuario();
    if (usuario.data[0] != null) {
      setlistemail(usuario.data);
      setFilteredEmails(usuario.data);
    }
  }

  async function buscaUsuario() {
    let response = await api.get('/pessoa/' + situacao);
    return response;
  }

  const editar = (value) => {
    navigate('/AlterarCadastro', { state: value });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const toggleExpand = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const handleDateChange = (event) => {
    const { name, value } = event.target;
    if (name === "dataInicio") {
      setDataInicio(value);
    } else {
      setDataFim(value);
    }
    filterEmails();
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    
    // Data do relatório
    doc.setFontSize(14);
    doc.text(`Data: ${new Date().toLocaleDateString('pt-BR')}`, 14, 20);
    doc.text(`Período: ${new Date(dataInicio).toLocaleDateString('pt-BR')} a ${new Date(dataFim).toLocaleDateString('pt-BR')}`, 14, 28);
    
    // Preparar dados da tabela
    const tableData = filteredEmails.map((email) => [
      email.nome,
      email.cpf,
      email.telefone || '-',
      `${email.cidade || ''} - ${email.estado || ''}`.replace(' - ', email.cidade && email.estado ? ' - ' : '').replace(/^- |^$/, email.cidade || email.estado || '-'),
      email.comoConheceu || '-',
      new Date(email.data_cadastro).toLocaleDateString('pt-BR')
    ]);
    
    // Configuração da tabela
    autoTable(doc, {
      head: [['Nome', 'CPF', 'Telefone', 'Localidade', 'Como Conheceu', 'Entrada']],
      body: tableData,
      startY: 35,
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: 'bold'
      },
      columnStyles: {
        0: { cellWidth: 40 },
        1: { cellWidth: 30 },
        2: { cellWidth: 25 },
        3: { cellWidth: 35 },
        4: { cellWidth: 35 },
        5: { cellWidth: 20 }
      }
    });
    
    // Salvar o PDF
    doc.save(`relatorio-emails-enviados-${new Date().toISOString().split('T')[0]}.pdf`);
  };



  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('pt-BR', options);
  };

  const formatQuestion = (value) => {
    return Number(value) === 1 ? "Sim" : "Não";
  };

  const handleSendFilteredEmail = async () => {
    setLoadingEmail(true);
    
    try {
      api.defaults.headers.post = { 'Content-Type': 'application/json' };
      api.defaults.headers.common = { 'x-access-token': localStorage.getItem("token") };

      const filterData = {
        dataInicio: dataInicio || undefined,
        dataFim: dataFim || undefined,
        situacao: '1'
      };

      // Remove campos undefined
      Object.keys(filterData).forEach(key => 
        filterData[key] === undefined && delete filterData[key]
      );

      const response = await api.post('/send-filtered/', filterData);

      if (response.status === 200) {
        alert('Email enviado com sucesso!');
      } else {
        alert('Falha ao enviar email');
      }
    } catch (error) {
      console.error('Erro ao enviar email:', error);
      alert('Erro ao enviar email');
    } finally {
      setLoadingEmail(false);
    }
  };

  const handleDownloadFile = async () => {
    setLoadingDownload(true);
    
    try {
      api.defaults.headers.common = { 'x-access-token': localStorage.getItem("token") };

      const params = new URLSearchParams();
      if (dataInicio) params.append('dataInicio', dataInicio);
      if (dataFim) params.append('dataFim', dataFim);
      params.append('situacao', '1');

      const response = await api.get(`/download-arquivo/?${params.toString()}`, {
        responseType: 'blob'
      });

      // Criar link temporário para download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Extrair nome do arquivo do header ou usar nome padrão
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'arquivo.xlsx';
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch) {
          fileName = fileNameMatch[1];
        }
      } else {
        fileName = `arquivo-${new Date().toISOString().split('T')[0]}.xlsx`;
      }
      
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      alert('Erro ao baixar arquivo');
    } finally {
      setLoadingDownload(false);
    }
  };

  return (
    <div className="home-container">
      <div className="home-header">
        <FaBars className="menu-icon" onClick={() => setSidebar(true)} />
        <Sidebar active={sidebar} setActive={setSidebar} />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSendFilteredEmail}
          disabled={loadingEmail}
          style={{ marginLeft: 'auto', marginRight: '10px' }}
        >
          {loadingEmail ? <CircularProgress size={24} /> : 'Enviar Email'}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleDownloadFile}
          disabled={loadingDownload}
          style={{ marginRight: '10px' }}
        >
          {loadingDownload ? <CircularProgress size={24} /> : 'Baixar Arquivo'}
        </Button>
        {currentConfig.showSmartTalksExport && (
          <Button
            variant="contained"
            color="success"
            onClick={() => downloadSmartTalksCsv(filteredEmails, 'smart-talks-enviados')}
            disabled={filteredEmails.length === 0}
            style={{ marginRight: '10px' }}
          >
            Smart Talks
          </Button>
        )}
        <Button
          variant="outlined"
          color="primary"
          onClick={generatePDF}
        >
          Imprimir PDF
        </Button>
      </div>
      <div className="home-list">
        <legend>
            <Typography variant="h4">E-mails Enviados</Typography>
        </legend>
        <div className="search-container">
          <TextField
            label="Data Início"
            type="date"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={dataInicio}
            onChange={handleDateChange}
            name="dataInicio"
            margin="normal"
            style={{ marginRight: isMobile ? 0 : 10 }}
          />
          <TextField
            label="Data Fim"
            type="date"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={dataFim}
            onChange={handleDateChange}
            name="dataFim"
            margin="normal"
            style={{ marginRight: isMobile ? 0 : 10 }}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={atividadeFilter}
                onChange={(e) => setAtividadeFilter(e.target.checked)}
                color="primary"
              />
            }
            label="Somente quem participou de atividade"
            style={{ marginLeft: 8, marginTop: 20}}
          />
          <TextField
            label="Buscar"
            variant="outlined"
            fullWidth
            margin="normal"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          
        </div>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: '5px' }} />
                <TableCell style={{ padding: '5px' }}>Nome</TableCell>
                <TableCell style={{ padding: '5px' }}>CPF</TableCell>
                {!isMobile && <TableCell style={{ padding: '5px' }}>Telefone</TableCell>}
                <TableCell style={{ padding: '5px' }}>Localidade</TableCell>
                <TableCell style={{ padding: '5px' }}>Entrada</TableCell>
                <TableCell style={{ padding: '5px' }}>Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredEmails.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      Nenhum registro encontrado
                    </TableCell>
                  </TableRow>
                ) : (
                filteredEmails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((email) => (
                  <React.Fragment key={email.id}>
                    <TableRow className="home-list-item">
                      <TableCell style={{ padding: '5px' }}>
                        <IconButton onClick={() => toggleExpand(email.id)}>
                          {expandedRow === email.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                      </TableCell>
                      <TableCell className="item-info" style={{ padding: '5px' }}>{email.nome}</TableCell>
                      <TableCell style={{ padding: '5px' }}>{email.cpf}</TableCell>
                      {!isMobile && <TableCell style={{ padding: '5px' }}>{email.telefone}</TableCell>}
                      <TableCell style={{ padding: '5px' }}>
                        {`${email.cidade || ''} - ${email.estado || ''}`.replace(' - ', email.cidade && email.estado ? ' - ' : '').replace(/^- |^$/, email.cidade || email.estado || '-')}
                      </TableCell>
                      <TableCell style={{ padding: '5px' }}>
                        {new Date(email.data_cadastro).toLocaleDateString('pt-BR')}
                      </TableCell>
                      <TableCell className="item-actions" style={{ padding: '5px' }}>
                        <IconButton onClick={() => editar(email)} className="action-button">
                          <Edit />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                        <Collapse in={Boolean(expandedRow === email.id)} timeout="auto" unmountOnExit>
                          <Box margin={1} padding={2} border={1} borderRadius={2} borderColor="grey.300">
                            <Typography variant="h6" gutterBottom style={{ fontSize: '1rem', fontWeight: 'bold' }}>
                              Informações Adicionais
                            </Typography>

                            {!isMobile && email.telefone && (
                              <Typography style={{ fontSize: '0.9rem', fontWeight: 'bold', marginTop: 8 }}>
                                📞 Telefone: <span style={{ fontWeight: 'normal' }}>{email.telefone}</span>
                              </Typography>
                            )}

                            {email.data_cadastro && (
                              <Typography style={{ fontSize: '0.9rem', fontWeight: 'bold', marginTop: 8 }}>
                                📅 Entrada: <span style={{ fontWeight: 'normal' }}>{formatDate(email.data_cadastro)}</span>
                              </Typography>
                            )}

                            {email.comoConheceu && (
                              <Typography style={{ fontSize: '0.9rem', fontWeight: 'bold', marginTop: 8 }}>
                                🔍 Como nos conheceu: <span style={{ fontWeight: 'normal' }}>{email.comoConheceu}</span>
                              </Typography>
                            )}

                            {email.pergunta1 !== null ? (
                              <Typography variant="h6" gutterBottom style={{ fontSize: '1rem', fontWeight: 'bold', marginTop: 16 }}>
                                Questionário de Saúde
                              </Typography>
                            ) : null}

                            {[
                              { label: 'Problemas cardíacos', value: email.pergunta1 },
                              { label: 'Gestante', value: email.pergunta2 },
                              { label: 'Dificuldades respiratórias ou asma', value: email.pergunta3 },
                              { label: 'Desmaios, epilepsia e/ou convulsões', value: email.pergunta4 },
                              { label: 'Em período pós-operatório', value: email.pergunta5 },
                              { label: 'Problemas ósseos e/ou na coluna vertebral', value: email.pergunta6 },
                              { label: 'Sob efeito de álcool e/ou entorpecentes', value: email.pergunta7 },
                              { label: 'Fobia de altura', value: email.pergunta8 },
                            ].map(
                              (item, index) =>
                                item.value !== null && (
                                  <Typography key={index} style={{ fontSize: '0.9rem', marginTop: 8 }}>
                                    <strong>❓ {item.label}:</strong>{' '}
                                    <span
                                      style={{
                                        fontWeight: item.value === 1 ? 'bold' : 'normal',
                                        color: item.value === 1 ? 'red' : 'inherit',
                                      }}
                                    >
                                      {formatQuestion(item.value)}
                                    </span>
                                  </Typography>
                                )
                            )}
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredEmails.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Linhas por página"
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
        />
      </div>
    </div>
  );
}